import styled from 'styled-components';
import { images } from 'config';
import { shades} from 'utils';
const { teals } = shades;

const ExternalLink = styled.a`
  color: ${teals.tilicho};
  cursor: pointer;  
  &:after {
    content: '';
    display: inline-block;
    width: 11px;
    height: 11px;
    background: url('${images.icons.link}') no-repeat;
    margin: 0 10px 0 3px;
  }

`;

export default ExternalLink;



// WEBPACK FOOTER //
// ./src/components/styled/ui/externalLink/externalLink.js